import {Button, Flex} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleDown, faAngleRight,
    faCode, faFolder,
    faFolderOpen,
    faSquare
} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {faFolder as farFaFolder, faFolderOpen as farFaFolderOpen} from "@fortawesome/free-regular-svg-icons";
import {DraftComponents} from "../../../../../../../../feature/Draft";

export const SettingItem = (
    props: {
        setting: DraftComponents,
        active?: boolean,
        fullFilled?: boolean,
        showEmbeddingState?: boolean,
        expanded?: boolean,
        embedded?: boolean,
        children?: React.ReactNode,
        onExpand?: (setting: DraftComponents) => void,
        onSelected?: (setting: DraftComponents) => void
    }
) => {

    return (
        <Flex
            vertical={true}
            gap={10}
        >
            <Button
                type={'dashed'}
                style={{
                    textAlign: 'start',
                    height: "auto",
                    background: props.active ? "#f0f0f0" : undefined,
                    padding: '8px 8px 8px 16px'
                }}
                onDoubleClick={() => {
                    props.onExpand?.(props.setting)
                }}
                onClick={() => {
                    props.onSelected?.(props.setting)
                }}
            >
                <Flex
                    style={{width: "100%"}}
                    justify={'space-between'}
                    gap={10}
                    align={'center'}>

                    <FontAwesomeIcon
                        style={{color: props.fullFilled == true ? "#0958d9" : props.fullFilled == false ? "#cccccc" : "#faad14"}}
                        fontSize={16}
                        icon={props.expanded ? (props.fullFilled ? faFolderOpen : farFaFolderOpen) : props.fullFilled ? faFolder : farFaFolder}
                    />

                    <div
                        style={{
                            flexGrow: 1,
                            textOverflow: 'ellipsis',
                            overflow: 'hidden'
                        }}
                    >
                        {props.setting.title && props.setting.title?.trim().length > 0 ? props.setting.title : "Setting"}
                    </div>

                    <Flex gap={10} align={'center'}>
                        <span className="fa-layers fa-fw fa-lg" style={{display: props.showEmbeddingState ? 'block' : 'none'}}>
                            <FontAwesomeIcon
                                icon={faSquare}
                                color={props.embedded == true ? "#17813b" : props.embedded == false ? "#ccc" : "#faad14"}
                            />
                            <FontAwesomeIcon
                                icon={faCode}
                                className={"fa-inverse"}
                                transform="shrink-8"/>
                        </span>
                        <FontAwesomeIcon
                            style={{
                                background: "#ffffff",
                                border: "1px solid #eee",
                                borderRadius: 20,
                                padding: 5,
                                aspectRatio: 1
                            }}
                            icon={props.expanded ? faAngleDown : faAngleRight}
                            onClick={(e) => {
                                props.onExpand?.(props.setting)
                                e.stopPropagation()
                            }}/>
                    </Flex>
                </Flex>
            </Button>
            <Flex
                style={{marginLeft: 20}}
                vertical={true}
                gap={10}>
                {props.expanded ? props.children : ''}
            </Flex>
        </Flex>
    )
}